<template>
    <shared-schedules-list
        :individual-mode="true"
        :institution-account="isInstitution"
        :allow-modifying="!!isProviderOwnerOrAdmin"
        :breadcrumbs="breadcrumbs"
    />
</template>
<script>

    import SharedSchedulesList from '../../components/providers/schedule/SharedSchedulesList'
    import {mapMutations, mapState} from 'vuex'

    export default{
        components: {
            SharedSchedulesList
        },
        data(){
            return {
                breadcrumbs: [
                    {
                        text: 'Listado Agendas',
                        disabled: true,
                        href: ''
                    }
                ],
            }
        },
        mounted(){},
        methods: {},
        computed: {
            ...mapState(['currentUser', 'currentProvider', 'currentBranchOffice']),
            isInstitution(){
                return !!this.currentProvider && !!this.currentProvider.institution
            },
            isProviderOwnerOrAdmin(){
                var vm = this
                return !!vm.currentProvider && !!vm.currentProvider.role &&
                        (vm.currentProvider.role.is_owner || vm.currentProvider.role.is_admin)
            }
        },
        watch: {}
    }
</script>